import { render, staticRenderFns } from "./contractRentMonthlyDashboard.vue?vue&type=template&id=2589c2a7&scoped=true&"
import script from "./contractRentMonthlyDashboard.vue?vue&type=script&lang=js&"
export * from "./contractRentMonthlyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589c2a7",
  null
  
)

export default component.exports